import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import audio from "assets/videos/audio.mp3";
const PostMedia6 = () => {
    return (
        <div className="post-image">
            <AudioPlayer
                // src="http://example.com/audio.mp3"
                src={audio}
                // onPlay={(e) => console.log("onPlay")}
                // other props here
            />
        </div>
    );
};

export default PostMedia6;
